export default "__VITE_ASSET__b681da9f__"